import { Meteor } from 'meteor/meteor';
import { check } from 'meteor/check';
import { keys } from 'lodash';
import Tasks from '../Tasks';
import { STATUS_TYPES } from '../taskConstants';

Meteor.publish('tasks', function tasks() {
  return Tasks.find({ owner: this.userId });
});

// Note: tasks.view is also used when editing an existing document.
Meteor.publish('tasks.view', function tasksView(taskId) {
  check(taskId, String);
  return Tasks.find({ _id: taskId, owner: this.userId });
});

Meteor.publish('tasks.reuseSavedTasks', function tasksReuseSavedTasks() {
  return Tasks.find(
    { owner: this.userId, status: { $in: keys(STATUS_TYPES.properties) } },
    {
      fields: {
        comments: 0,
        createdAt: 0,
        finishedAt: 0,
        owner: 0,
        processId: 0,
        progress: 0,
        startedAt: 0,
        updatedAt: 0
      }
    }
  );
});
